// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/icons' // icon
import axios from 'axios'
import $ from 'jquery';
import https from "@/https.js";
import 'babel-polyfill'
import message from './message';
import {saveAs} from 'file-saver'
// import plTable from 'pl-table'

// import 'pl-table/themes/index.css' // 引入样式（必须引入)，vuecli3.0不需要配置，cli2.0请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦

// import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）

// Vue.use(plTable);

//axios.defaults.baseURL = '/api'  //关键代码

Vue.config.productionTip = false
Vue.use(Element);
Vue.use(message);
Vue.prototype.$axios = axios
import global_ from '@/components/Global'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面
const config = require('@/components/Global');
window.addEventListener('beforeunload', e => {

  sessionStorage.setItem("store", JSON.stringify(config.default.userinfo));
  sessionStorage.setItem("storedl", JSON.stringify(config.default.dailiinfo));
  sessionStorage.setItem("storebm", JSON.stringify(config.default.spbm));
  sessionStorage.setItem("storetoken", JSON.stringify(config.default.token));
  sessionStorage.setItem("storexsfname", JSON.stringify(config.default.xsfname));
  sessionStorage.setItem("storexsfsbh", JSON.stringify(config.default.xsfsbh));
  sessionStorage.setItem("storexsfdz", JSON.stringify(config.default.xsfdz));
  sessionStorage.setItem("storexsfkh", JSON.stringify(config.default.xsfkh));

});

window.addEventListener('unload', e => {
  //https://blog.csdn.net/robin90814/article/details/90603369



  if (config.default.token) {
    $.ajax({
      headers: {
        "token": config.default.token
      },
      url: 'http://zhushou.huasivip.com/admin/api/public/index/getxmls/loginout',
      type: 'get',
      async: false, //或false,是否异步

    })

  }

});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // components: { App },
  // template: '<App/>',
  render: h => h(App),

  created() {

    let url = window.location.href.toLocaleLowerCase();
    config.default.agentinfo.zhuce=true;
    if (url.indexOf('zhushou.huasivip.com') > -1 || url.indexOf("http://localhost:8000")>-1) {
      config.default.agent = false;
    }
    else {
      config.default.agent = true;
    
      {
       
     
       
     
        if (url.indexOf('localhost:8000') > -1)
        
        { 
         
          
          config.default.agentinfo.qq="455586546";
         config.default.agentinfo.phone="13635715047";
         config.default.agentinfo.wx="13635715047"
        }
        
        
      }
    }
    if (sessionStorage.getItem("store") || sessionStorage.getItem("storedl")) {

      config.default.userinfo = JSON.parse(sessionStorage.getItem("store"))
      config.default.dailiinfo = JSON.parse(sessionStorage.getItem("storedl"))
      config.default.spbm = JSON.parse(sessionStorage.getItem("storebm"))
      config.default.token = JSON.parse(sessionStorage.getItem("storetoken"))
      config.default.xsfname = JSON.parse(sessionStorage.getItem("storexsfname"));
      config.default.xsfsbh = JSON.parse(sessionStorage.getItem("storexsfsbh"));
      config.default.xsfdz = JSON.parse(sessionStorage.getItem("storexsfdz"));
      config.default.xsfkh = JSON.parse(sessionStorage.getItem("storexsfkh"));


      sessionStorage.removeItem("storedl")
      sessionStorage.removeItem("store")
      sessionStorage.removeItem("storebm")
      sessionStorage.removeItem("storetoken")
      sessionStorage.removeItem("storexsfname")
      sessionStorage.removeItem("storexsfsbh")
      sessionStorage.removeItem("storexsfdz")
      sessionStorage.removeItem("storexsfkh")


    }
    if (this.$route.path.indexOf("login") <= -1) {

      if (config.default.token) {
        // $.ajax({
        //   headers: {
        //     "token": config.default.token
        //   },
        //   url: 'http://zhushou.huasivip.com/admin/api/public/index/getxmls/loginref',
        //   type: 'get',
        //   async: false, //或false,是否异步

        // })
        https
          .fetchPost("http://zhushou.huasivip.com/admin/api/public/index/getxmls/loginref", "")
          .then(data => {
          });

      }
    }
  },

})





// WEBPACK FOOTER //
// ./src/main.js